export const AI_SHARING_VERSION = '2026-10-13';
